<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import { computed } from 'vue';
import { useSortPreference } from '~/composables/sort-preference';
import IconClockDesc from '~icons/mdi/sort-clock-descending-outline';
import IconCheck from '~icons/ph/check-bold';
import IconCalendar from '~icons/ph/calendar-blank';
import IconTime from '~icons/carbon/time';
import IconAlpha from '~icons/bi/alphabet-uppercase';
import IconArrowUp from '~icons/heroicons/arrow-long-up';

const { t } = useI18n();
const { savedSort, updateSort, sortOptions } = useSortPreference();

const IconSort = computed(() => {
  const { sortBy } = savedSort.value;

  if (sortBy === 'name') {
    return IconAlpha;
  }

  if (sortBy === 'created_at') {
    return IconCalendar;
  }

  if (sortBy === 'updated_at') {
    return IconTime;
  }

  return IconClockDesc;
});
</script>

<template>
  <Menu as="div" class="three-dot-menu">
    <MenuButton aria-label="Sort options" class="three-dot-menu__btn icon-block h-8">
      <div
        v-tooltip="{
          content: t('tooltips.sort_options'),
        }"
        class="flex items-center justify-center"
      >
        <component :is="IconSort" aria-hidden="true" class="text-sm" />
        <IconArrowUp
          class="-ml-0.5 -mr-1 text-sm"
          :class="[savedSort.sortOrder === 'desc' ? 'rotate-180' : '']"
          aria-hidden="true"
        />
      </div>
    </MenuButton>

    <transition name="animate-menu-panel">
      <MenuItems class="three-dot-menu__panel --right min-w-[8rem]">
        <template v-for="item in sortOptions" :key="item">
          <hr v-if="item.id === 'spacer'" class="border-t-3 mx-1 my-1 dark:border-t-new-gray-400" />

          <MenuItem v-else-if="item.value">
            <button
              class="three-dot-menu__item-btn gap-1 pl-1 pr-2.5"
              @click="updateSort(item.value)"
            >
              <IconCheck
                class="text-xs"
                :aria-hidden="item.value === savedSort"
                :class="[
                  item.value.sortBy === savedSort.sortBy &&
                  item.value.sortOrder === savedSort.sortOrder
                    ? ''
                    : 'opacity-0',
                ]"
              />
              <span
                class="three-dot-menu__item-text"
                :data-content="item.text"
                v-text="item.text"
              />
            </button>
          </MenuItem>
        </template>
      </MenuItems>
    </transition>
  </Menu>
</template>
